export default __webpack_public_path__ + "static/media/MuseoSans_700-webfont.0cd20fbf.svg";